(function ($) {
  $('.elementor-field-type-submit button').click(function(){      
    if($(this).closest('.elementor-form').find('.elementor-acceptance-field').length > 0) {
      $(this).closest('.elementor-form').find('.elementor-acceptance-field').each(function(){
        if($(this).is(':checked')){
          $(this).removeClass('invalid')
        } else {
          $(this).addClass('invalid')
        }
      });
    }
  });

  $('.elementor-acceptance-field').change(function(){      
    if($(this).is(':checked')){
      $(this).removeClass('invalid')
    } else {
      $(this).addClass('invalid')
    }
  });

  if ($('#form-field-project_url_field').length > 0) {
    // Get the current URL
    var currentURL = window.location.href;

    // Use jQuery to set the value of the input field
    $('#form-field-project_url_field').val(currentURL);
  }
  

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/partials/forms.js